import { Unit } from "uom";
// Discrete
// export const Integer = _register(Unit.createProductUnit<q.Discrete>("Discrete", []), " ");
export var Integer = Unit.createBase("Integer", "Discrete", " ");
//# sourceMappingURL=discrete.js.map